// extracted by mini-css-extract-plugin
export default {"form":"string-page_form__6P556","hint":"string-page_hint__KGBWR","result":"string-page_result__tZiwz"};